export default "__VITE_ASSET__BnoVd5gP__"